import { TankGame } from './game/TankGame.js';
import { OnlinePvP } from './game/OnlinePvP.js';
import { UIController } from './ui/UIController.js';
import { syncVisitCounter } from './visit-counter.js';

const canvas = document.getElementById('game-canvas');
if (!(canvas instanceof HTMLCanvasElement)) throw new Error('Game canvas not found');

const ui = new UIController();
const game = new TankGame(canvas, ui);
// 联机对战协调器：大厅/房间/对局/结算的流转与消息路由（构造即完成 UI 动作接线）。
new OnlinePvP(ui, game);

(window as any).__TOON_TANK_INSTANCE__ = game;
(window as any).__TOON_TANK_UI__ = ui;
syncVisitCounter();
